// possible values for Checkbox colors.
export enum CheckboxColors {
  PRIMARY = 'primary', // checkbox with gz blue (primary) color
  ERROR = 'error', // checkbox with gz error color
}

export type CheckboxColor = CheckboxColors.PRIMARY | CheckboxColors.ERROR;

export enum CheckboxEvent {
  CHANGED = 'change',
}
